<div class="search-display-container d-flex flex-column h-100 overflow-hidden">
  @if (agentId) {
    <!-- Header: always full width -->
    <lib-chat-panel-hdr
      [title]="agentLabel"
      [agents]="[]"
      [selectedAgentId]="agentId"
      [showMinimize]="false"
      (newChatRequested)="startNewChat()" />

    <!-- Chat: fills remaining height, chat container centered at max-width -->
    <div class="ai-view-chat-wrapper flex-fill min-h-0 d-flex justify-content-center overflow-hidden">
      @for (key of [currentThreadId()]; track key) {
        <lib-chat-container
          class="ai-view-chat-container flex-fill min-h-0"
          [agentId]="agentId"
          [idleConfig]="idleConfig"
          [threadId]="key" />
      }
    </div>
  } @else {
    <div class="no-agent-configured d-flex flex-column align-items-center justify-content-center flex-fill gap-2">
      <p>No AI agent configured</p>
    </div>
  }
</div>
